import React from 'react';
import './RegistrationForm/RegistrationForm.css';

export default function ValidationError(props) {
  if(props.message) {
    return (
      <div className="error">{props.message}</div>
    );
  }

  return <></>
}